import BackArrow from "../../../../components/backArrow";
import { images } from "../../../../constants/index";
import Rating from "@mui/material/Rating";
import { useMemo, useState } from "react";
import { useGetServiceDetailQuery, useGetServicesByUserAndCategoryQuery } from "../../../../features/service/serviceApiSlice";
import { useGetShopRatingQuery, usePostSuggestionMutation } from "../../../../features/shop/shopApiSlice";
import { useGetUserInfoQuery } from "../../../../features/user/userApiSlice";
import Typography from "@mui/material/Typography";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import "./service.css";
import Reportbox from "../../../../components/Reportbox";
import Reportselectezibox from "../../../../components/Report to selectezi";
import ConnectProfileModal from "../../../../components/Connect_Modal_Buy";
import { useGetAllConnectedQuery } from "../../../../features/connection/connectionApiSlice";
import Suggestionbox from "../../../../components/Suggestionbox";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import ShareIcon from '@mui/icons-material/Share';

import ServicesPortfolio from "../servicesPortfolio/index";
import RatingModel from "../../../../components/ProductsRating";
import { useNavigate } from "react-router-dom";
import PlaceIcon from "@mui/icons-material/Place";
import ReportIcon from "@mui/icons-material/Report";
import StarIcon from "@mui/icons-material/Star";
import ChatIcon from "@mui/icons-material/Chat";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import Qrmodal from "../../../../components/QRmodal/Qrmodal";
import url from "../../../../config/axios";
import { getAsset } from "../../../../helpers/helper";
import ReplyIcon from "@mui/icons-material/Reply";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { SuccessNotify, FailedNotify } from "../../../../constants/tostify";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";
import { Carousel } from "react-bootstrap";
import Back from "../../../../components/backArrow";
import profileimage from "../../../../assets/images/newservice/Unsplash-Avatars_0004s_0007_nathan-dumlao-Ju--S80ezyU-unsplash.png";
import noImagePlaceholder from "../../../../assets/images/dummy/no_image_placeholder.png";
import rectangle from "../../../../assets/images/newservice/Rectangle 30136.png";
import book1 from "../../../../assets/images/newservice/book1.png";
import book2 from "../../../../assets/images/newservice/book2.png";
import DescriptionIcon from "@mui/icons-material/Description";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CampaignIcon from "@mui/icons-material/Campaign";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import ShareModel from "../../../../components/Sharemodel";
import ShareOption from "../../../../components/Shareoption";
import RedoIcon from "@mui/icons-material/Redo";
import AddServiceModal from "../../../../components/Servicemodal_one";
import AddExperienceModal from "../../../../components/Service_Experience";
import AddCertificateeModal from "../../../../components/Service_Certificate";
import AboutServiceModal from "../../../../components/Service_About";
import CertificateModal from "../../../../components/Certificate_view_modal";
import PeopleRatingsModal from '../../../../components/Rating_People';
import GradeIcon from "@mui/icons-material/Grade";
import MassengerModals from "../../../../components/Navbar/MassengerModal";
const ServicesOnlineBio = ({ id, setShow, shopid }) => {
  const [qrmodal, setQrmodal] = useState(false);
  const [value] = useState(3);
  const [key, setKey] = useState("home");
  const { name } = useSelector((state) => state?.user);
  const [lgShowreport, setLgShowreport] = useState(false);
  const [selectezireport, setSelectezireport] = useState(false);
  const [smShow, setSmShow] = useState(0);
  const [showrating, setShowrating] = useState();
  const [showoneModal, setShowoneModal] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [showconnect, setShowconnect] = useState(false);
  const [lgShow, setLgShow] = useState(0);
  const [lgMsgShow, setLgMsgShow] = useState(false);
  const [servicesdata, setServicesdata] = useState([]);
  const [aboutdata, setAboutdata] = useState('');
  const [experience, setExperience] = useState([]);
  const [certificate, setCertificate] = useState([]);
  const [certificateid, setCertificateid] = useState('');

  const { data: serviceDetailRes, isLoading: isServiceLoading } = useGetServiceDetailQuery(id, { skip: !id });
  const shopdata = serviceDetailRes?.data?.Service || '';

  const { data: userServicesRes } = useGetServicesByUserAndCategoryQuery(
    { userid: shopdata?.userid, categoryid: shopdata?.categoryid },
    { skip: !shopdata?.userid || !shopdata?.categoryid }
  );

  const { data: ratingRes } = useGetShopRatingQuery(shopid, { skip: !shopid });

  // `shopdata` (fetched by this exact service's own id) already carries its
  // own serviceArray/about/experienceArray/certificateArray. The
  // user+category query above can return a *different* service document
  // when the same user has more than one service under that category, which
  // was making the About/Experience/Certificate sections show the wrong
  // (or empty) data. Source them straight from the service being viewed.
  useEffect(() => {
    if (shopdata) {
      setServicesdata(shopdata.serviceArray || []);
      setAboutdata(shopdata.about || '');
      setExperience(shopdata.experienceArray || []);
      setCertificate(shopdata.certificateArray || []);
    }
  }, [shopdata]);

  useEffect(() => {
    if (ratingRes?.data?.averageRating !== undefined) {
      setShowrating(ratingRes.data.averageRating);
    }
  }, [ratingRes]);

  const [suggestion, setSuggestion] = useState({
    vendorid: "",
    userid: name?._id,
    username: name?.fullname,
    useremail: name?.email,
    role: "",
    imageUrl: "",
  });

  const navigate = useNavigate();
  const handleClose = () => setShowModal(0);
  const [showshare, setShowshare] = useState(false);
  const [showModal, setShowModal] = useState(0);
  const [showcertificate, setShowcertificate] = useState(false);
  const [showpeoplerating, setShowpeoplerating] = useState(false);
  const handleClosepeople = () => setShowpeoplerating(false);
  const handleShowpeople = () => setShowpeoplerating(true);

  const handleCloseshare = () => {
    setShowshare(0);
    setShow(1);
  };

  const handleCloseconnect = () => {
    setShowconnect(false);
  };
  const onHide = () => {
    setQrmodal(false);
  };

  const { data: connectedDataResponse } = useGetAllConnectedQuery(
    { userid: name?._id },
    { skip: !name?._id, refetchOnMountOrArgChange: true }
  );
  const matchesShop = (list, targetShopId) =>
    (list || []).some(
      (c) =>
        c.senderid === targetShopId ||
        c.recieverid === targetShopId ||
        c.sendershopid === targetShopId ||
        c.recievershopid === targetShopId
    );
  const isThisShopRequested = matchesShop(
    connectedDataResponse?.requested,
    shopdata?._id
  );

  const { data: userInfoRes } = useGetUserInfoQuery(name?._id, { skip: !name?._id });
  const [postSuggestion] = usePostSuggestionMutation();

  useEffect(() => {
    if (userInfoRes?.data?.User?.imageUrl) {
      setSuggestion((prevState) => ({
        ...prevState,
        imageUrl: userInfoRes.data.User.imageUrl,
        vendorid: id,
      }));
    } else if (id) {
      setSuggestion((prevState) => ({
        ...prevState,
        vendorid: id,
      }));
    }
  }, [userInfoRes, id]);

  const suggestHandel = (e) => {
    setSuggestion((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  
  const suggestPost = (e) => {
    e?.preventDefault?.();
    setIsloading(true);
    postSuggestion(suggestion)
      .unwrap()
      .then((res) => {
        SuccessNotify("Suggestion Add Success");
        setLgShow(0);
        setIsloading(false);
        setSuggestion({
          ...suggestion,
          role: "",
        });
      })
      .catch((error) => {
        setLgShow(0);
        setIsloading(false);
        FailedNotify("Failed to post suggestion Data");
      });
  };

  const ownerUserId = useMemo(() => {
    const raw = shopdata?.userid;
    if (!raw) return null;
    if (typeof raw === "object") return raw._id || raw.id || null;
    return raw;
  }, [shopdata?.userid]);

  const initialUserForChat = useMemo(() => {
    if (!ownerUserId) return null;
    const img = Array.isArray(shopdata?.images)
      ? shopdata.images[0]
      : shopdata?.images || null;
    return {
      _id: ownerUserId,
      fullname: shopdata?.profileName || "Service Provider",
      image: img,
    };
  }, [ownerUserId, shopdata?.profileName, shopdata?.images]);

  const handleOpenMessage = () => {
    if (!initialUserForChat?._id) {
      FailedNotify("User not found");
      return;
    }
    if (name?._id && String(name._id) === String(initialUserForChat._id)) {
      FailedNotify("You cannot message yourself");
      return;
    }
    setLgMsgShow(true);
  };

  return (
    <>
      <MassengerModals
        lgMsgShow={lgMsgShow}
        setLgMsgShow={setLgMsgShow}
        initialUser={initialUserForChat}
        onInitialUserConsumed={() => {}}
      />
      <Qrmodal show={qrmodal} handleClosemodal={onHide} />
      <Suggestionbox
        lgShow={lgShow}
        setLgShow={setLgShow}
        suggestion={suggestion}
        suggestHandel={suggestHandel}
        suggestPost={suggestPost}
      />
      <ConnectProfileModal
        connectbuyModal={showconnect}
        setConnectbuyModal={setShowconnect}
        shopData={shopdata}
      />
      <RatingModel setSmShow={setSmShow} smShow={smShow} shopid={shopid} />
      <Reportbox
        lgshowreport={lgShowreport}
        setLgShowreport={setLgShowreport}
        shopid={id}
      />

      <PeopleRatingsModal
        show={showpeoplerating}
        handleClosepeople={handleClosepeople} />

      <Reportselectezibox
        selectezireport={selectezireport}
        setSelectezireport={setSelectezireport}
        shopid={id}
      />

      <Container fluid>
        <ShareOption
          showshare={showshare}
          handleCloseshare={handleCloseshare}
        />
        <AddServiceModal show={showModal} handleClose={() => setShowModal(0)} />
        <CertificateModal
          show={showcertificate}
          setShowcertificate={setShowcertificate}
          id={id}
          certificateid={certificateid}
        />
        <AboutServiceModal
          show={showModal}
          handleClose={() => setShowModal(0)}
        />

        <AddCertificateeModal
          show={showModal}
          handleClose={() => setShowModal(0)}

        />
        <AddExperienceModal
          show={showModal}
          handleClose={() => setShowModal(0)}
        />
        {/* <ShareModel
        showmodal={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
        
      /> */}
        {/* Go Back Button - Included as it's below navbar in screenshot */}
        <Row className="mb-3">
          <Col>
            <Button variant="link" className="go-back">
              <Back />
            </Button>
          </Col>
          <Col className="text-end">
            <button
              onClick={() => setShow(1)}
              className="text-white bg-blue  rounded mt-2 pt-1 pb-1 ps-4 pe-4"
              style={{
                backgroundColor: "#0353a4",
                border: "none",
                fontSize: "11px",
              }}
            >
              Share <RedoIcon className="share_icon_f" />
            </button>
          </Col>
        </Row>

        {/* Profile Header */}
        <Row className="profile-header align-items-start bg-white p-4 rounded">
          <Col xs={12} md={2} className="text-center">
            {isServiceLoading ? (
              <Skeleton circle={true} height={150} width={150} className="mb-3" />
            ) : (
              <img
                src={shopdata?.images ? getAsset(shopdata?.images) : profileimage}
                alt={shopdata?.profileName || "User Avatar"}
                className="profile-photo rounded-circle mb-3"
                crossOrigin="anonymous"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = profileimage;
                }}
              />
            )}
          </Col>
          <Col xs={12} md={10}>
            <Row>
              <Col md={8}>
                <h4 className="mb-0">{shopdata?.profileName}</h4>
                <p className="text-muted font_14 mb-0">Profile id {shopdata?.serviceid}</p>
                <p className="text-muted font_14 mb-0">{`${shopdata?.country}, ${shopdata?.state},${shopdata?.city}`}</p>
                <p className="text-muted font_14 mb-0">{shopdata?.address}</p>
                <div className="d-flex flex-wrap m-1 ms-0">
                  <Badge pill className="me-2 mb-2 badge-silver">
                    {shopdata?.subCategory}
                  </Badge>
                  {/* <Badge pill className="me-2 mb-2 badge-silver">
                    UI/UX
                  </Badge>
                  <Badge pill className="me-2 mb-2 badge-silver">
                    Posters Designs
                  </Badge>
                  <Badge pill className="me-2 mb-2 badge-silver">
                    Branding
                  </Badge> */}
                </div>
                <div className="d-flex align-items-center mb-2">
                  {showrating && showrating.length > 0 ? (
                    <div className="d-flex">
                      <GradeIcon fontSize="small" />
                      <p className="mb-1 font_small">
                        <Typography
                          component="legend"
                          className="font_small mt-1 "
                        >
                          <b>{showrating}</b>
                        </Typography>
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  &nbsp;&nbsp;
                  <button
                    className="text-white rounded pt-0 pb-0 ps-3 pe-3 border-0 font_11"
                    style={{ backgroundColor: "#0353a4" }}
                    onClick={handleShowpeople}
                  >
                    View Rating
                  </button>
                </div>
              </Col>
              <Col
                md={4}
                className="text-end d-flex flex-column justify-content-start"
              >
                <div>
                  <QrCode2Icon fontSize="large" />
                </div>


                <button className="mb-2 custom-available-button rounded w-50 ms-auto mt-2 mb-2">
                  <FiberManualRecordIcon fontSize="small" />
                  Available
                </button>
                <Row>
                  <Col lg="6">
                    <Button
                      variant="primary "
                      className="w-100 mb-2 pt-1 pb-1"
                      onClick={handleOpenMessage}
                    >
                      <ChatBubbleIcon fontSize="small" /> Message
                    </Button>
                  </Col>

                  <Col lg="6">
                    <Button
                      variant="primary "
                      className=" w-100 mb-2 pt-1 pb-1"
                    >
                      <CallIcon fontSize="small" />
                      Call
                    </Button>
                  </Col>
                </Row>

                <Button
                  variant="primary"
                  onClick={() => {
                    if (!shopid || !ownerUserId) {
                      FailedNotify("Unable to open consultancy services");
                      return;
                    }
                    navigate(
                      `/view-consultancy-services-profile/${shopid}/${ownerUserId}`,
                    );
                  }}
                >
                  View Consultancy Services
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Tabs */}
<Row className="tabs-row services-actions-row bg-white p-3 rounded mt-3">
  <Col xs={6} lg="auto" className="services-action-item">
    <span role="button" className="font_13" onClick={() => setSmShow(true)}>
      <StarIcon style={{ color: "#ffc107" }} />
      <span className="services-action-label">Rate this Shop</span>
    </span>
  </Col>

  <Col xs={6} lg="auto" className="services-action-item">
    <span
      role="button"
      className="font_13"
      style={
        isThisShopRequested
          ? { color: "#856404", cursor: "default" }
          : undefined
      }
      onClick={() => setShowconnect(true)}
    >
      <ShareIcon
        style={{ color: isThisShopRequested ? "#ffc107" : "#0353a4" }}
      />
      <span className="services-action-label">
        {isThisShopRequested ? "Request Sent" : "Send Connection Request"}
      </span>
    </span>
  </Col>

  <Col xs={6} lg="auto" className="services-action-item">
    <span role="button" className="font_13" onClick={() => setLgShow(true)}>
      <CampaignIcon style={{ color: "green" }} />
      <span className="services-action-label">Suggestion to Owner</span>
    </span>
  </Col>

  <Col xs={6} lg="auto" className="services-action-item">
    <span
      role="button"
      className="font_13"
      onClick={() => setLgShowreport(true)}
    >
      <ReportProblemIcon style={{ color: "orange" }} />
      <span className="services-action-label">Report to Owner</span>
    </span>
  </Col>

  <Col xs={6} lg="auto" className="services-action-item">
    <span
      role="button"
      className="font_13"
      onClick={() => setSelectezireport(true)}
    >
      <ReportIcon style={{ color: "red" }} />
      <span className="services-action-label">Report to Selectezi</span>
    </span>
  </Col>
</Row>

        {/* Services */}
        <Row className="mt-4">
          <Col lg="12" className=" text-left">
            <h5>Services</h5>
          </Col>
        </Row>
        <Row>
          {servicesdata?.map((service, index) => (
            <Col xs={12} md={6} lg={6} key={index} className="p-3">
              <Row className="service-card h-100">
                <Col lg="4" className="pe-0">
                  <Card.Img
                    variant="top"
                    src={service?.images ? getAsset(service?.images) : noImagePlaceholder}
                    alt="service-img"
                    className="service-img"
                    crossOrigin="anonymous"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = noImagePlaceholder;
                    }}
                  />
                </Col>

                <Col lg="8" className="ps-0">
                  <Card.Body>
                    <Card.Title className="service-title">
                      {service.heading}
                    </Card.Title>
                    <Card.Text className="service-text font_14">
                      {service.detail.length > 160
                        ? `${service.detail.substring(0, 160)}...read more`
                        : service.detail}
                    </Card.Text>
                    <div

                      className="service-link"
                      onClick={() => navigate(`/view-service-buying/${service._id}/${id}/?type=service`)}
                    >
                      View details
                    </div>
                  </Card.Body>
                </Col>
              </Row>
            </Col>
          ))}
        </Row>

        {/* About — hide heading + card when empty */}
        {String(aboutdata || "").trim() ? (
          <>
            <Row className="mt-4">
              <Col lg="12" className=" text-left">
                <h5> About</h5>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card className="about-card">
                  <Card.Body>
                    <Card.Text className="font_14">
                      {aboutdata}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </>
        ) : null}

        {/* Experience — hide when none added */}
        {Array.isArray(experience) &&
        experience.some(
          (item) =>
            item &&
            (item.name ||
              item.profileName ||
              item.projectName ||
              item.detail ||
              (Array.isArray(item.images) && item.images.length > 0)),
        ) ? (
          <>
            <Row className="mt-4">
              <Col lg="12" className="text-left">
                <h5>Experience </h5>
              </Col>
            </Row>

            <Container className="my-4">
              <Row>
                {experience.map((service, expIndex) => (
                  <Col
                    key={service._id || service.id || expIndex}
                    xs={12}
                    sm={6}
                    lg={4}
                    className="mb-4"
                  >
                    <Card className="custom-service-card shadow-sm h-100 border-0">
                      <div className="custom-carousel-wrapper">
                        <Carousel interval={null} indicators={true}>
                          {(service?.images?.length
                            ? service.images
                            : [null]
                          ).map((img, index) => (
                            <Carousel.Item key={index}>
                              <Card.Img
                                variant="top"
                                src={img ? getAsset(img) : noImagePlaceholder}
                                crossOrigin="anonymous"
                                alt="service-img"
                                className="custom-carousel-image"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = noImagePlaceholder;
                                }}
                              />
                            </Carousel.Item>
                          ))}
                        </Carousel>
                      </div>
                      <Card.Body>
                        <Card.Title className="fw-semibold">
                          {service?.name || service?.profileName}
                        </Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">
                          {service?.projectName}
                        </Card.Subtitle>
                        <Card.Text className="text-muted small font_14">
                          {(service?.detail || "").length > 160
                            ? `${service.detail.substring(0, 160)}...read more`
                            : service?.detail}
                        </Card.Text>
                        <Button
                          variant="primary"
                          className="rounded-pill w-100 px-4 pt-1 pb-1  mt-2"
                          style={{ backgroundColor: "#0353a4", border: "none" }}
                          onClick={() =>
                            navigate(
                              `/view-service-buying/${service._id}/${id}/?type=experience`,
                            )
                          }
                        >
                          View details
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Container>
          </>
        ) : null}

        {/* Certifications — hide when none added */}
        {Array.isArray(certificate) &&
        certificate.some((cert) => cert && (cert.name || cert.issueDate || cert.img)) ? (
          <>
            <Row className="mt-4">
              <Col lg="12" className="text-left">
                <h5>Certifications </h5>
              </Col>
            </Row>

            <Row className="g-4">
              {certificate.map((cert, certIndex) => (
                <Col key={cert._id || cert.id || certIndex} xs={12} md={4}>
                  <Card className="cert-card">
                    <Card.Body className="d-flex align-items-start">
                      <DescriptionIcon
                        fontSize="large"
                        style={{ color: "#0353a4" }}
                      />
                      <div>
                        <Card.Title className="cert-title mb-1">
                          {cert.name}
                        </Card.Title>
                        <Card.Text className="cert-date mb-1">
                          Issue date: {cert.issueDate}
                        </Card.Text>
                        <div
                          className="cert-link"
                          onClick={() => {
                            setCertificateid(cert._id);
                            setShowcertificate(true);
                          }}
                        >
                          View Details
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        ) : null}
      </Container>
    </>
  );
};
export default ServicesOnlineBio;
